module.exports = __webpack_public_path__ + "img/marketing_sharing.40bfc357.svg";